import React from 'react'
import ComingSoon from '../components/ComingSoon'

const MainLayout = () => {
    return (
        <>
            <ComingSoon />
        </>
    )
}

export default MainLayout